const _temp0 = require("./rahms-first-report-card.json");
module.exports = {
  "rahms-first-report-card": _temp0
}